import React from 'react';

interface BlobProps {
  className?: string;
  color?: string;
  style?: React.CSSProperties;
  variant?: 1 | 2 | 3 | 4;
}

export const Blob: React.FC<BlobProps> = ({
  className = '',
  color = 'rgba(201,123,99,0.08)',
  style = {},
  variant = 1,
}) => {
  const paths = {
    1: "M120,-148C159,-115,183,-64,196,-7C209,50,211,112,179,145C147,178,81,184,22,189C-36,193,-72,197,-110,182C-148,168,-188,134,-198,86C-208,38,-187,-22,-158,-66C-129,-110,-92,-136,-52,-160C-12,-183,33,-204,86,-193C139,-181,81,-181,120,-148Z",
    2: "M140,-160C180,-140,210,-90,220,-30C230,30,220,100,180,150C140,200,70,230,0,230C-70,230,-140,200,-180,150C-220,100,-230,30,-220,-30C-210,-90,-180,-140,-140,-160C-100,-180,-50,-180,0,-180C50,-180,100,-180,140,-160Z",
    3: "M100,-120C130,-100,155,-60,170,-10C185,40,190,100,165,140C140,180,85,200,25,205C-35,210,-95,200,-135,165C-175,130,-195,70,-190,15C-185,-40,-155,-90,-115,-115C-75,-140,-35,-140,10,-150C55,-160,70,-140,100,-120Z",
    4: "M110,-130C145,-105,175,-65,190,-15C205,35,205,95,180,135C155,175,105,195,50,200C-5,205,-65,195,-105,165C-145,135,-165,85,-170,30C-175,-25,-165,-85,-135,-120C-105,-155,-55,-165,-5,-160C45,-155,75,-155,110,-130Z"
  };

  return (
    <svg
      viewBox="0 0 600 600"
      className={className}
      style={{ position: 'absolute', pointerEvents: 'none', ...style }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(300,300)">
        <path
          d={paths[variant]}
          fill={color}
        />
      </g>
    </svg>
  );
};
